// src/helpers/inputValidation.ts

export type InputValidationType = 'textWithÑ' | 'numeric' | 'alphanumeric'

export const getInputPropsByType = (type: InputValidationType) => {
  switch (type) {
    case 'textWithÑ':
      return {
        pattern: "^[a-zA-ZñÑáéíóúÁÉÍÓÚ\\s]+$",
        title: 'Solo letras, espacios, tildes y la letra ñ',
        onInput: (e: React.ChangeEvent<HTMLInputElement>) => {
          e.target.value = e.target.value.replace(/[^a-zA-ZñÑáéíóúÁÉÍÓÚ\s]/g, '')
        }
      }
    case 'numeric':
      return {
        pattern: "^[0-9]+$",
        title: 'Solo números',
        onInput: (e: React.ChangeEvent<HTMLInputElement>) => {
          e.target.value = e.target.value.replace(/[^0-9]/g, '')
        }
      }
    case 'alphanumeric':
      return {
        pattern: "^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ\\s]+$",
        title: 'Solo letras, números, tildes y la letra ñ',
        onInput: (e: React.ChangeEvent<HTMLInputElement>) => {
          e.target.value = e.target.value.replace(/[^a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ\s]/g, '')
        }
      }
    default:
      return {}
  }
}
